import { connect } from 'react-redux';

import {
  accessibilityDefaultTheme,
  accessibilityBaseFontSize,
  accessibilityIsOpenToggle
} from '../../../redux/actions/accessibility';

import AccessibilityMeta from './accessibilityMeta';

const mapStateToProps = ({ accessibility, app }) => ({
  defaultTheme: accessibility.defaultTheme,
  baseFontSize: accessibility.baseFontSize,
  accessibilityIsOpen: accessibility.isOpen,
  currentSiteTheme: app.pageData.siteTheme || app.pageData.globalTheme || 'default'
});

const mapDispatchToProps = dispatch => ({
  updateDefaultTheme: status => {
    dispatch(accessibilityDefaultTheme(status));
  },
  updateBaseFontSize: size => {
    dispatch(accessibilityBaseFontSize(size));
  },
  handleAccessibilityOpen: isOpen => {
    if (isOpen) {
      dispatch(accessibilityIsOpenToggle());
    }
  }
});
export default connect(mapStateToProps, mapDispatchToProps)(AccessibilityMeta);
